import 'css-chunksrc/client/scenes/optimizedGantt/header/derivationToggle/styles.scss';export default {
  "delayToggle": "_delayToggle_o8rft_1",
  "icon": "_icon_o8rft_10",
  "text": "_text_o8rft_16"
};